require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-paul-conrad-interviewed-in-australian-design-review.json") })
        }
      }, "path---journal-paul-conrad-interviewed-in-australian-design-review");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-paul-conrad-interviewed-in-australian-design-review!./.cache/json/journal-paul-conrad-interviewed-in-australian-design-review.json
// module id = 521
// module chunks = 231608221292675